import React from "react";
import "./WhatWeOffer.css"; // Optional for custom styles
import layout from "../../assets/img/agent-man.png";
import layout_m from "../../assets/img/bgLayout.svg";
import agent from "../../assets/img/claims.svg";

const offers = [
  {
    icon: "car.svg",
    title: "Automobile Insurance",
    description:
      "Drive protected, drive assured: Your trusted auto insurance partner.",
  },
  {
    icon: "tick.svg",
    title: "SR22 Insurance",
    description: "Keeping you on the road with confidence and compliance.",
  },
  {
    icon: "key.svg",
    title: "Non-Owner’s Policy",
    description: "Protect yourself with non-owner's auto insurance.",
  },
  {
    icon: "file.svg",
    title: "Commercial Auto Insurance",
    description: "Protect your fleet that protects every mile.",
  },
  {
    icon: "dollor.svg",
    title: "Low Rates & Money-Saving Discounts",
    description: "Maximize your money with our discounts.",
  },
  {
    icon: "chat.svg",
    title: "Expert Advice from Your Local Agent",
    description: "Expert advice, just around the corner whenever you need.",
  },
  {
    icon: "p-coverage.svg",
    title: "Personalized Coverage Options",
    description: "Designed to address the individual needs of each customer.",
  },
  {
    icon: "agent-icon.svg",
    title: "Products & Services Tailored to the Needs of Independent Agents",
    description: "Keeping you on the road with confidence and compliance.",
  },
];

const WhatWeOffer = ({ responsiveStatus }) => {
  const leftOffers = offers.slice(0, 4);
  const rightOffers = offers.slice(4);

  return (
    <>
      {/* <h2 className="text-center fw-bold mb-4">
        
        <div className="border-bottom border-primary mx-auto mt-2" style={{ width: "60px" }}></div>
      </h2> */}

      <div
        style={
          responsiveStatus === "isDesktop"
            ? styles.container
            : responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
            ? styles.container
            : styles.container_M
        }
        className={`${
          responsiveStatus === "isDesktop"
            ? "align-items-center"
            : responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
            ? "align-items-center"
            : "align-items-left"
        }`}
      >
        {responsiveStatus === "isMobile" ||
        responsiveStatus === "isSmallMobile" ? (
          <p
            className={`${
              responsiveStatus === "isDesktop"
                ? "fw-bold text-left heading mb-4"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "fw-bold text-left heading mb-4"
                : "fw-bold text-left heading ml-2"
            }`}
            style={{ color: "#000", marginBottom: "1rem", fontSize: "17px" }}
          >
            <span
              style={{
                borderBottom: "2px solid #0E72D6",
                paddingBottom: "4px",
              }}
            >
              What We Offe
            </span>
            r
          </p>
        ) : (
          <p
            className="fw-bold text-center heading"
            style={{ color: "#000", marginBottom: "10rem" }}
          >
            Wh
            <span
              style={{
                borderBottom: "2px solid #0E72D6",
                paddingBottom: "10px",
              }}
            >
              at We Of
            </span>
            fer
          </p>
        )}
        {/* Left column */}
        <div
          // className="row"
          style={{
            margin: "0 auto",
            maxWidth: "1350px",
            display:
              responsiveStatus === "isDesktop"
                ? "flex"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "flex"
                : "block",
            flexDirection: "row",
          }}
        >
          <div className="col-md-4 col-12">
            {leftOffers.map((item, index) => (
              <div className="d-flex align-items-start mb-4" key={index}>
                <div className="bg-light rounded-circle p-1 me-3">
                  <img
                    src={require(`../../assets/img/${item.icon}`)} // Replace with your image path
                    alt="Description"
                    style={{
                      width: "35px",
                      height: "35px",
                    }}
                  />
                </div>
                <div>
                  <span className="fw-bold mb-1" style={{ fontSize: "1rem" }}>
                    {item.title}
                  </span>

                  <p
                    className="text-muted mb-0"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Image in center */}
          <div className="col-md-4 col-12 text-center mb-4 mb-md-0">
            {(responsiveStatus === "isMobile" ||
              responsiveStatus === "isSmallMobile") && (
              <img
                src={agent}
                alt="Agent"
                className="img-fluid"
                style={{ maxHeight: "auto" }}
              />
            )}
          </div>

          {/* Right column */}
          <div className="col-md-4 col-12">
            {rightOffers.map((item, index) => (
              <div className="d-flex align-items-start mb-4" key={index}>
                <div className="bg-light rounded-circle p-1 me-3">
                  <img
                    src={require(`../../assets/img/${item.icon}`)}
                    alt="Description"
                    style={{
                      width: "35px",
                      height: "35px",
                    }}
                  />
                </div>
                <div>
                  <span className="fw-bold mb-1" style={{ fontSize: "1rem" }}>
                    {item.title}
                  </span>

                  <p
                    className="text-muted mb-0"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "745px",
    marginLeft: "5px",
  },
  container_M: {
    backgroundImage: `url(${layout_m})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "auto",
    marginLeft: "5px",
  },
};

export default WhatWeOffer;
